import { Component, Input, Output, EventEmitter, ViewChild, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import * as Modalcomponent from '../Modal/modal.component';
import { DateModalComponent } from '../DateModal/dateModal.component';
import { ICellChangedEvent } from './cellValueChanged.event';
import { IColumn } from './column.interface';

@Component( {
    selector: 'app-date',
    templateUrl: 'dateEditor.component.html',
    styleUrls: ['dateEditor.component.css']
})

export class DateEditorComponent implements OnChanges, OnDestroy {

    @Input() row: number;
    @Input() col: IColumn;
    @Input() date: Date;
    @Input() allowAdd = true;
    @Output() dateChanged = new EventEmitter<ICellChangedEvent>();
    @Output() dateAdded = new EventEmitter<ICellChangedEvent>();
    @ViewChild( Modalcomponent.ModalComponent ) modal: Modalcomponent.ModalComponent;
    @ViewChild( DateModalComponent ) dateModal: DateModalComponent;

    private isShown = false;
    private adding = false;
    private hasFocus = false;
    private mouseLocation: { left: number, top: number } = { left: 0, top: 0 };
    private sizeColor = '';
    private editDate: Date;

    // the css for the container div
    get locationCss() {
        return {
            'position': 'fixed',
            'display': this.isShown ? 'block' : 'none',
            left: this.mouseLocation.left + 'px',
            top: this.mouseLocation.top + 'px'
        };
    }

    getDate()
    {
        this.dateModal.buttons = ['Cancel', 'Ok'];
        this.dateModal.show(( btn: string, date: Date) =>
        {
            if ( btn == 'Ok' )
            {
                this.editDate = date;
                this.onAccept();
            }
            else
            {
                this.onCancel();
            }
        });
    }

    onAdd()
    {
        this.modal.message = 'Are you sure you want to create a new order for Style and Color ' + this.sizeColor;
        this.modal.buttons = ['Yes', 'No'];
        this.modal.show((button: string) =>
        {
            if (button && button == 'Yes') {
                this.adding = true;
                // this.isShown = true;
                this.getDate();
            }
        });
    }

    onEdit() {
        this.getDate();
    }

    private pad( num, size ) {
        let s = '000000000' + num;
        return s.substr( s.length - size );
    }

    private raiseDateChanged() {
        if (!this.hasFocus) {
            return;
        }
        let thisDate = new Date(this.editDate);
        let date = thisDate.getFullYear() + '-' + ( '0' + ( thisDate.getMonth() + 1 ) ).slice( -2 ) + '-' + ( '0' + thisDate.getDate() ).slice( -2 );
        this.dateChanged.emit( {
            row: this.row,
            col: this.col,
            oldValue: this.date,
            newValue: date,
            cancel: null
        });
        this.hasFocus = false;
        this.dateChanged.complete();
        this.dateAdded.complete();
    }

    private raiseDateAdded() {
        if (!this.hasFocus) {
            return;
        }
        let thisDate = new Date(this.editDate);
        let date = thisDate.getFullYear() + '-' + ( '0' + ( thisDate.getMonth() + 1 ) ).slice( -2 ) + '-' + ( '0' + thisDate.getDate() ).slice( -2 );
        this.dateAdded.emit( {
            row: this.row,
            col: this.col,
            oldValue: null,
            newValue: date,
            cancel: null
        });
        this.hasFocus = false;
        this.dateAdded.complete();
        this.dateChanged.complete();
    }

    onAccept() {
        // this.date = this.editDate;
        this.adding ? this.raiseDateAdded() : this.raiseDateChanged();
    }

    onCancel() {
        this.dateChanged.emit( {
            row: this.row,
            col: this.col,
            oldValue: this.date,
            newValue: this.date,
            cancel: null
        });
    }

    takeFocus( x, y, row ) {
        if ( !this.hasFocus ) {
            this.sizeColor = row['styleColor'];
            this.mouseLocation.left = x;
            this.mouseLocation.top = y;
            this.hasFocus = true;
        }
    }

    getValue() {
        return this.date;
    }

    ngOnChanges( change: SimpleChanges ) {
        if (change['date']) {
            this.editDate = new Date( this.date );
        }
    }
    
    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Grid/dateEditor.component.ts